import React from 'react';
import { Helmet } from 'react-helmet';
import { useCenturionHomepageContent } from '@/hooks/cdaasHooks/cdaasHelperHooks';
import {
  TclMigrationFeatures,
  useTCLFeatureFlags,
} from '@/hooks/featureFlagHooks';
import { useCommonContent } from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';
import { CenturionNetworkHero } from './CenturionNetworkHero';
import { CenturionIntroSection } from './CenturionIntroSection';
import { CenturionCarrouselSection } from './CenturionCarrouselSection';
import { CenturionNetworkLounges } from './CenturionNetworkLounges';
import { CenturionNetworkFAQs } from './CenturionNetworkFAQs';
import { CenturionHomepage } from '../CulinaryCollective/interface';
import GlobalLoungeCollectionBanner from './GlobalLoungeCollectionBanner';

const CenturionNetworkPage = () => {
  const centurionHomepageContent: CenturionHomepage =
    useCenturionHomepageContent();
  const isGLCBannerEnabled = useTCLFeatureFlags(
    TclMigrationFeatures.GLC_BANNER
  );
  const {
    pageTitles: { centurionNetwork },
  } = useCommonContent();

  const {
    title,
    pageIntro,
    threeUpBlocks: networkHighlights,
    hero,
  } = centurionHomepageContent;

  return (
    <>
      <Helmet>
        <title>{centurionNetwork?.title}</title>
        <meta name="description" content={centurionNetwork?.description} />
      </Helmet>
      <div className="tw-flex tw-flex-col">
        <CenturionNetworkHero content={hero} />
        <div className="tw-mx-auto tw-flex tw-flex-col tw-px-4 md_tw-px-6 lg_tw-max-w-360 lg_tw-px-8 xl_tw-px-10">
          <CenturionIntroSection
            title={title}
            intro={pageIntro}
            networkHighlights={networkHighlights}
          />
        </div>
        <div className="tw-flex tw-flex-col">
          <CenturionCarrouselSection />
        </div>
        <div className="tw-mx-auto tw-flex tw-flex-col tw-px-4 md_tw-px-6 md_tw-pt-20 lg_tw-max-w-360 lg_tw-px-8 xl_tw-px-10">
          <CenturionNetworkLounges />
        </div>
        <div className="tw-mx-auto tw-w-full tw-px-4 md_tw-px-6 lg_tw-max-w-360 lg_tw-px-8 xl_tw-px-10">
          <CenturionNetworkFAQs />
        </div>
        {isGLCBannerEnabled && (
          <div className="tw-mx-auto tw-mt-10 tw-w-full tw-px-4 md_tw-px-6 lg_tw-max-w-360 lg_tw-px-8 xl_tw-px-10">
            <GlobalLoungeCollectionBanner />
          </div>
        )}
      </div>
    </>
  );
};

export default CenturionNetworkPage;
